// extracted by mini-css-extract-plugin
export default {"couponParent1":"CouponTemplate_couponParent1__l6GSS","limitedOffer":"CouponTemplate_limitedOffer__6Ewh7","loader":"CouponTemplate_loader__Gq1yO","spin":"CouponTemplate_spin__nL-wq"};